import { Session } from '@services/session';

import {
  IResponseCompanyConnection,
  USER_ACCOUNT_TYPE,
} from '@services/company.interface';

export enum PERMISSIONS {
  ALL = 'all',
  NONE = '',

  ASSETS_LOCATIONS_READ = 'asset_locations.read',
  ASSETS_READ = 'assets.read',
  DRIVERS_LOCATION_READ = 'driver_locations.read',
  DRIVER_LICENSE_MANAGE = 'driver_license.manage',
  DRIVERS_READ = 'drivers.read',
  VEHICLES_LOCATIONS_READ = 'vehicle_locations.read',
  VEHICLES_READ = 'vehicles.read',
  LOGS_READ = 'logs.read',
  LOGS_MANAGE = 'logs.edit',
  LOGS_IGNORE_DRIVE_TIME = 'logs.edit.ignore_drive_time',
  MESSAGES_MANAGE = 'messages.manage',
  DRIVER_PERFORMANCE_MANAGE = 'driver_performance.manage',
  VIDEO_MONITORING_READ = 'video_monitoring.read',
  SMART_LOAD_BOARD_READ = 'smart_load_board.read',
  TRIPS_MANAGE = 'driving_periods.manage',
  DOCUMENTS_MANAGE = 'documents.manage',
  DOCUMENT_TEMPLATES_MANAGE = 'document_templates.manage',
  DRIVER_AND_VEHICLE_DOCUMENT_MANAGE = 'driver_and_vehicle_document.manage',
  DRIVER_QUALIFICATION_DOCUMENTS_READ = 'driver_qualification_documents.read',
  DRIVER_QUALIFICATION_DOCUMENTS_MANAGE = 'driver_qualification_documents.manage',
  DRIVER_QUALIFICATION_DOCUMENTS_TEMPLATE_READ = 'driver_qualification_document_templates.read',
  DRIVER_QUALIFICATION_DOCUMENTS_TEMPLATE_MANAGE = 'driver_qualification_document_templates.manage',
  FAULT_CODES_READ = 'fault_codes.read',
  INSPECTION_REPORTS_MANAGE = 'inspection_reports.manage',
  MAINTENANCE_MANAGE = 'maintenance.manage',
  EMISSION_MANAGE = 'emission.manage',
  IFTA_READ = 'ifta.read',
  FUEL_PURCHASE_MANAGE = 'fuel_purchase.manage',
  IDLING_READ = 'idling.read',
  FUEL_INSIGHTS = 'fuel_insights.read',
  CSA_INSIGHTS = 'csa_insights.read',
  CSA_ACTIVITY = 'csa_activity.read',
  DISPATCHES_READ = 'kt_dispatches.read',
  DISPATCHES_MANAGE = 'kt_dispatches.manage',

  APP_MARKETPLACE_READ = 'app_marketplace.read',
  VIDEO_RECALL_READ = 'video_recall.read',
  VIDEO_RECALL_MANAGE = 'video_recall.manage',
  LIVE_STREAM_MANAGE = 'live_stream.manage',
  DRIVERS_MANAGE = 'drivers.manage',
  VEHICLES_MANAGE = 'vehicles.manage',
  FLEET_USERS_MANAGE = 'fleet_users.manage',
  ASSETS_MANAGE = 'assets.manage',
  GROUPS_MANAGE = 'groups.manage',
  ELD_DEVICES_MANAGE = 'eld_devices.manage',
  DEVICES_HUB_MANAGE = 'devices_hub.manage',
  REBOOT_VEHICLE_GATEWAY_MANAGE = 'reboot_vehicle_gateway.manage',
  ALERTS_MANAGE = 'alerts.manage',
  DEVELOPER_ACCESS_MANAGE = 'developer_access.manage',
  GEOFENCE_MANAGE = 'geofence.manage',
  COMPANY_MANAGE = 'company.manage',
  SAFETY_SETTINGS_MANAGE = 'safety_settings.manage',
  VEHICLE_GATEWAY_ASSIGN = 'vehicle_gateways.assign',
  UNSAFE_BEHAVIOR_DETECTION_SETTINGS_READ = 'unsafe_behavior_detection_settings.read',
  VEHICLES_UNSAFE_BEHAVIOR_DETECTION_SETTING_MANAGE = 'vehicles_unsafe_behavior_detection_setting.manage',
  ASSET_GATEWAY_ASSIGN = 'asset_gateways.assign',
  USER_ROLES_MANAGE = 'user_roles.manage',
  DRIVER_HUB_MANAGE = 'driver_hub.manage',
  THERMOKING_CONTROL_MANAGE = 'thermoking_control.manage',
  VIDEO_DOWNLOAD_READ = 'video_downloading.read',
  CONFIDENTIAL_VIDEO_DOWNLOAD_READ = 'confidential_video_downloading.read',
  ELD_DISCONNECTS_READ = 'eld_disconnects.read',
  DISMISS_SAFETY_EVENTS_MANAGE = 'dismiss_safety_events.manage',
  DRIVER_WALKTHROUGH_MANAGE = 'driver_walkthrough.manage',
  COACH_DRIVER_PERMITTED = 'coach_drivers.permitted',
  COACH_DRIVER_ASSIGNED = 'coach_drivers.assigned',
  MESSAGING_TEAMS_MANAGE = 'messaging_teams.manage',
  TIMECARDS_READ = 'timecards.read',
  TIMECARDS_MANAGE = 'timecards.manage',
  WORKFORCE_MANAGE = 'workforce.manage',
  TIMECARDS_SETTINGS_MANAGE = 'timecards_settings.manage',
  REPORTS_READ = 'reports.read',
  SHOP_MANAGE = 'shop.manage',
  BILLING_MANAGEMENT_MANAGE = 'billing_management.manage',
  TRAINING_READ = 'training.read',
  TRAINING_MANAGE = 'training.manage',
  MVR_MANAGE = 'motor_vehicle_record.manage',
  // new permission which where previously checked by session.isAdmin() function
  // & don't come under the scope of Admin Module
  APP_MARKETPLACE_MANAGE = 'app_marketplace.manage',
  AUDIT_LOGS_READ = 'audit_trail.read',
  FACE_MATCH_MANAGE = 'face_match.manage',
  COACH_SAFETY_EVENTS_MANAGE = 'coach_safety_events.manage',
  COACH_LOGS_MANAGE = 'coach_logs.manage',
  MARK_EVENTS_COACHABLE_MANAGE = 'mark_events_coachable.manage',
  CONDUCT_COACHING_EVENTS_MANAGE = 'conduct_coaching_events.manage',
  MARK_LOGS_COACHABLE_MANAGE = 'mark_logs_coachable.manage',
  CONDUCT_COACHING_LOGS_MANAGE = 'conduct_coaching_logs.manage',
  OEM_ENTITIES_READ = 'oem_entities.read',
  MOTIVE_ANALYTICS_READ = 'motive_analytics.read',
  MOTIVE_ANALYTICS_MANAGE = 'motive_analytics.manage',
  CONFIDENTIAL_READ = 'confidential.read',
  CONFIDENTIAL_ASSIGN = 'confidential.assign',
  CONFIDENTIAL_UNASSIGN = 'confidential.unassign',
  BEHAVIOR_TAGS_MANAGE = 'behavior_tags.manage',
  SEVERITY_MANAGE = 'severity.manage',
  IMAGE_MONITORING_READ = 'image_monitoring.read',
  COLLISION_REPORT_MANAGE = 'collision_report.manage',
  DRIVER_PRIVACY_MANAGE = 'driver_privacy.manage',
  CUSTOM_AI_COACH_MANAGE = 'custom_ai_coach.manage',
  VOICE_CALL_MANAGE = 'voice_call.manage',

  // Driver Rewards
  DRIVER_REWARDS_MANAGE = 'driver_rewards.manage',
  DRIVER_REWARDS_READ = 'driver_rewards.read',

  // Fleet cards
  CARD_HOLDERS_READ = 'card_holders.read',
  CARD_TRANSACTION_READ = 'card_transactions.read',
  CARD_TRANSACTION_MANAGE = 'card_transactions.manage',
  CARD_MISSED_SAVINGS_READ = 'card_missed_savings.read',

  CARD_ADMIN_READ = 'cards_admin.read',
  BANKS_AND_PAYMENTS_MANAGE = 'banks_and_payments.manage',
  PAYMENTS_AND_INVOICES_READ = 'payments_and_invoices.read',
  CARD_MANAGEMENT_MANAGE = 'card_management.manage',
  CARD_MANAGEMENT_READ = 'card_management.read',

  CARD_CONFIGURATION_MANAGE = 'cards_configuration.manage',

  // TODO: remove this in granular card permissions phase 2
  VIRTUAL_CARD_CONFIGURATION_MANAGE = 'virtual_card_configuration.manage', // to be renamed to CARD_MANAGEMENT_VIRTUAL_CARDS_ACTIVATE_DEACTIVATE
  CARD_MANAGEMENT_VIRTUAL_CARDS_ACTIVATE_DEACTIVATE = 'card_management.virtual_cards.activate_deactivate',

  // Fleet cards - granular permissions
  POLICY_MANAGEMENT_MANAGE = 'policy_management.manage',
  CARD_ORDER_MANAGEMENT_READ = 'card_order_management.read',
  CARD_MANAGEMENT_CHANGE_POLICIES = 'card_management.change_policies',
  CARD_ORDER_MANAGEMENT_PHYSICAL_CARDS = 'card_order_management.physical_cards',
  CARD_MANAGEMENT_LOCK_UNLOCK_AND_FREEZE_CARDS = 'card_management.lock_unlock_freeze_cards',
  CARD_MANAGEMENT_MANAGE_SECURITY_CONTROLS = 'card_management.manage_security_controls',
  CARD_MANAGEMENT_CHANGE_POLICIES_TEMP_OVERRIDES = 'card_management.change_policies.temp_overrides',
  CARD_MANAGEMENT_PHYSICAL_CARDS_ACTIVATE_DEACTIVATE_REASSIGN = 'card_management.physical_cards.activate_reassign_deactivate',
  CARD_MANAGEMENT_PHYSICAL_AND_VIRTUAL_CARDS_DEACTIVATE = 'card_management.physical_and_virtual_cards.deactivate',

  // Driver codes
  CARDS_CONFIGURATION_DRIVER_CODES_MANAGE = 'cards_configuration.driver_codes.manage',

  // Tachograph (RTD Compliance)
  TACHOGRAPH_FILES_READ = 'tachograph_files.read',
  TACHOGRAPH_FILES_ASSIGN = 'tachograph_files.assign',
}

export const ALL_ACCESSIBLE_GROUP_SCOPE: PERMISSIONS = PERMISSIONS.ALL;

export const FLEET_CARDS_DASHBOARD_PERMISSIONS: PERMISSIONS[] = [
  PERMISSIONS.CARD_HOLDERS_READ,
  PERMISSIONS.CARD_TRANSACTION_READ,
  PERMISSIONS.CARD_TRANSACTION_MANAGE,
  PERMISSIONS.CARD_MISSED_SAVINGS_READ,
];

export const FLEET_CARDS_ADMINISTRATIVE_PERMISSIONS: PERMISSIONS[] = [
  PERMISSIONS.CARD_ADMIN_READ,
  PERMISSIONS.BANKS_AND_PAYMENTS_MANAGE,
  PERMISSIONS.PAYMENTS_AND_INVOICES_READ,
  PERMISSIONS.CARD_MANAGEMENT_MANAGE,
  PERMISSIONS.CARD_MANAGEMENT_READ,
  PERMISSIONS.CARD_CONFIGURATION_MANAGE,
  PERMISSIONS.VIRTUAL_CARD_CONFIGURATION_MANAGE,

  // Fleet cards - granular permissions
  PERMISSIONS.POLICY_MANAGEMENT_MANAGE,
  PERMISSIONS.CARD_ORDER_MANAGEMENT_READ,
  PERMISSIONS.CARD_MANAGEMENT_CHANGE_POLICIES,
  PERMISSIONS.CARD_ORDER_MANAGEMENT_PHYSICAL_CARDS,
  PERMISSIONS.CARD_MANAGEMENT_VIRTUAL_CARDS_ACTIVATE_DEACTIVATE,
  PERMISSIONS.CARD_MANAGEMENT_MANAGE_SECURITY_CONTROLS,
  PERMISSIONS.CARD_MANAGEMENT_LOCK_UNLOCK_AND_FREEZE_CARDS,
  PERMISSIONS.CARD_MANAGEMENT_CHANGE_POLICIES_TEMP_OVERRIDES,
  PERMISSIONS.CARD_MANAGEMENT_PHYSICAL_AND_VIRTUAL_CARDS_DEACTIVATE,
  PERMISSIONS.CARD_MANAGEMENT_PHYSICAL_CARDS_ACTIVATE_DEACTIVATE_REASSIGN,
  PERMISSIONS.CARDS_CONFIGURATION_DRIVER_CODES_MANAGE,
];

export const DEVICES_HUB_PERMISSIONS: PERMISSIONS[] = [
  PERMISSIONS.DEVICES_HUB_MANAGE,
  PERMISSIONS.REBOOT_VEHICLE_GATEWAY_MANAGE,
];

// permissions which are come under the scope of Dashboard module
const DASHBOARD_PERMISSIONS: PERMISSIONS[] = [
  PERMISSIONS.ASSETS_LOCATIONS_READ,
  PERMISSIONS.ASSETS_READ,
  PERMISSIONS.DRIVERS_LOCATION_READ,
  PERMISSIONS.DRIVERS_READ,
  PERMISSIONS.VEHICLES_LOCATIONS_READ,
  PERMISSIONS.VEHICLES_READ,
  PERMISSIONS.LOGS_READ,
  PERMISSIONS.LOGS_MANAGE,
  PERMISSIONS.LOGS_IGNORE_DRIVE_TIME,
  PERMISSIONS.MESSAGES_MANAGE,
  PERMISSIONS.DRIVER_PERFORMANCE_MANAGE,
  PERMISSIONS.VIDEO_MONITORING_READ,
  PERMISSIONS.SMART_LOAD_BOARD_READ,
  PERMISSIONS.TRIPS_MANAGE,
  PERMISSIONS.DOCUMENTS_MANAGE,
  PERMISSIONS.DOCUMENT_TEMPLATES_MANAGE,
  PERMISSIONS.DRIVER_AND_VEHICLE_DOCUMENT_MANAGE,
  PERMISSIONS.FAULT_CODES_READ,
  PERMISSIONS.INSPECTION_REPORTS_MANAGE,
  PERMISSIONS.MAINTENANCE_MANAGE,
  PERMISSIONS.EMISSION_MANAGE,
  PERMISSIONS.IFTA_READ,
  PERMISSIONS.FUEL_PURCHASE_MANAGE,
  PERMISSIONS.IDLING_READ,
  PERMISSIONS.FUEL_INSIGHTS,
  PERMISSIONS.APP_MARKETPLACE_MANAGE,
  PERMISSIONS.APP_MARKETPLACE_READ,
  PERMISSIONS.VIDEO_RECALL_READ,
  PERMISSIONS.VIDEO_RECALL_MANAGE,
  PERMISSIONS.LIVE_STREAM_MANAGE,
  PERMISSIONS.VOICE_CALL_MANAGE,
  PERMISSIONS.DOCUMENT_TEMPLATES_MANAGE,
  PERMISSIONS.DRIVER_QUALIFICATION_DOCUMENTS_READ,
  PERMISSIONS.DRIVER_QUALIFICATION_DOCUMENTS_MANAGE,
  PERMISSIONS.DRIVER_QUALIFICATION_DOCUMENTS_TEMPLATE_READ,
  PERMISSIONS.DRIVER_QUALIFICATION_DOCUMENTS_TEMPLATE_MANAGE,
  PERMISSIONS.CSA_INSIGHTS,
  PERMISSIONS.CSA_ACTIVITY,
  PERMISSIONS.SMART_LOAD_BOARD_READ,
  PERMISSIONS.THERMOKING_CONTROL_MANAGE,
  PERMISSIONS.VIDEO_DOWNLOAD_READ,
  PERMISSIONS.CONFIDENTIAL_VIDEO_DOWNLOAD_READ,
  PERMISSIONS.ELD_DISCONNECTS_READ,
  PERMISSIONS.DISMISS_SAFETY_EVENTS_MANAGE,
  PERMISSIONS.DISPATCHES_READ,
  PERMISSIONS.DISPATCHES_MANAGE,
  PERMISSIONS.COACH_DRIVER_PERMITTED,
  PERMISSIONS.TIMECARDS_READ,
  PERMISSIONS.TIMECARDS_MANAGE,
  PERMISSIONS.WORKFORCE_MANAGE,
  PERMISSIONS.AUDIT_LOGS_READ,
  PERMISSIONS.COACH_SAFETY_EVENTS_MANAGE,
  PERMISSIONS.COACH_LOGS_MANAGE,
  PERMISSIONS.MARK_EVENTS_COACHABLE_MANAGE,
  PERMISSIONS.CONDUCT_COACHING_EVENTS_MANAGE,
  PERMISSIONS.MARK_LOGS_COACHABLE_MANAGE,
  PERMISSIONS.CONDUCT_COACHING_LOGS_MANAGE,
  PERMISSIONS.REPORTS_READ,
  PERMISSIONS.OEM_ENTITIES_READ,
  PERMISSIONS.MOTIVE_ANALYTICS_READ,
  PERMISSIONS.MOTIVE_ANALYTICS_MANAGE,
  PERMISSIONS.CONFIDENTIAL_READ,
  PERMISSIONS.CONFIDENTIAL_ASSIGN,
  PERMISSIONS.CONFIDENTIAL_UNASSIGN,
  PERMISSIONS.BEHAVIOR_TAGS_MANAGE,
  PERMISSIONS.SEVERITY_MANAGE,
  PERMISSIONS.TRAINING_READ,
  PERMISSIONS.TRAINING_MANAGE,
  PERMISSIONS.MVR_MANAGE,
  PERMISSIONS.IMAGE_MONITORING_READ,
  PERMISSIONS.COLLISION_REPORT_MANAGE,
  PERMISSIONS.DRIVER_PRIVACY_MANAGE,
  PERMISSIONS.CUSTOM_AI_COACH_MANAGE,
  PERMISSIONS.DRIVER_REWARDS_MANAGE,
  PERMISSIONS.DRIVER_REWARDS_READ,
  ...FLEET_CARDS_DASHBOARD_PERMISSIONS,
  ...DEVICES_HUB_PERMISSIONS,
];

// permissions which are come under the scope of Admin module
const ADMINISTRATIVE_PERMISSIONS: PERMISSIONS[] = [
  PERMISSIONS.DRIVERS_MANAGE,
  PERMISSIONS.DRIVER_LICENSE_MANAGE,
  PERMISSIONS.VEHICLES_MANAGE,
  PERMISSIONS.FLEET_USERS_MANAGE,
  PERMISSIONS.ASSETS_MANAGE,
  PERMISSIONS.GROUPS_MANAGE,
  PERMISSIONS.ELD_DEVICES_MANAGE,
  PERMISSIONS.ALERTS_MANAGE,
  PERMISSIONS.DEVELOPER_ACCESS_MANAGE,
  PERMISSIONS.GEOFENCE_MANAGE,
  PERMISSIONS.COMPANY_MANAGE,
  PERMISSIONS.VEHICLE_GATEWAY_ASSIGN,
  PERMISSIONS.UNSAFE_BEHAVIOR_DETECTION_SETTINGS_READ,
  PERMISSIONS.VEHICLES_UNSAFE_BEHAVIOR_DETECTION_SETTING_MANAGE,
  PERMISSIONS.USER_ROLES_MANAGE,
  PERMISSIONS.ASSET_GATEWAY_ASSIGN,
  PERMISSIONS.DRIVER_HUB_MANAGE,
  PERMISSIONS.DRIVER_WALKTHROUGH_MANAGE,
  PERMISSIONS.MESSAGING_TEAMS_MANAGE,
  PERMISSIONS.TIMECARDS_SETTINGS_MANAGE,
  PERMISSIONS.SHOP_MANAGE,
  PERMISSIONS.BILLING_MANAGEMENT_MANAGE,
  PERMISSIONS.FACE_MATCH_MANAGE,
  PERMISSIONS.SAFETY_SETTINGS_MANAGE,
];


export const allPermissions: PERMISSIONS[] = [
  ...DASHBOARD_PERMISSIONS,
  ...ADMINISTRATIVE_PERMISSIONS,
];

export class UserPermission {
  constructor(private session: Session) {
    this.addFleetCardAdministrativePermissions();
  }

  public isMarketplaceReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.APP_MARKETPLACE_READ);
  }

  public isMarketplaceManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.APP_MARKETPLACE_MANAGE);
  }

  public isLogsReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.LOGS_READ);
  }

  public isDevicesHubManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.DEVICES_HUB_MANAGE);
  }

  public isRebootVehicleGatewayManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.REBOOT_VEHICLE_GATEWAY_MANAGE);
  }

  public isLogsEditAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.LOGS_MANAGE);
  }

  public isLogsIgnoreDriveTimeAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.LOGS_IGNORE_DRIVE_TIME);
  }

  public isTripsManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.TRIPS_MANAGE);
  }

  public isEldDisconnectsAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.ELD_DISCONNECTS_READ);
  }

  public isCSAInsightsAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CSA_INSIGHTS);
  }

  public isCSAActivityAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CSA_ACTIVITY);
  }

  public isDocumentManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.DOCUMENTS_MANAGE);
  }

  public isDocumentTemplatesManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.DOCUMENT_TEMPLATES_MANAGE);
  }

  public isDriverAndVehicleDocumentManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.DRIVER_AND_VEHICLE_DOCUMENT_MANAGE);
  }

  public isFaultCodeReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.FAULT_CODES_READ);
  }

  public isMaintenanceManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.MAINTENANCE_MANAGE);
  }

  public isEmissionManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.EMISSION_MANAGE);
  }

  public isInspectionReportsManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.INSPECTION_REPORTS_MANAGE);
  }

  public isIftaReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.IFTA_READ);
  }

  public isFuelPurchaseManage(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.FUEL_PURCHASE_MANAGE);
  }

  public isSmartLoadBoardReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.SMART_LOAD_BOARD_READ);
  }

  public isMessageManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.MESSAGES_MANAGE);
  }

  public isDriverPerformanceManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.DRIVER_PERFORMANCE_MANAGE);
  }

  public isVideoMonitoringReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.VIDEO_MONITORING_READ);
  }

  /**
   * Checks whether the user has permission to view requested safety videos
   */
  public isVideoRecallReadAllowed(): boolean {
    const companyRecallEnabled: boolean = this.session.hasCompanyRecallEnabled() || this.session.hasCompanyRecallEnabledWithoutVideoMonitoring();
    return companyRecallEnabled && this.session.isFeatureAllowed(PERMISSIONS.VIDEO_RECALL_READ);
  }

  /**
   * Checks whether the user has permission to request safety videos
   */
  public isVideoRecallManageAllowed(): boolean {
    const companyRecallEnabled: boolean = this.session.hasCompanyRecallEnabled() || this.session.hasCompanyRecallEnabledWithoutVideoMonitoring();
    return companyRecallEnabled && this.session.isFeatureAllowed(PERMISSIONS.VIDEO_RECALL_MANAGE);
  }

  public isLiveStreamManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.LIVE_STREAM_MANAGE);
  }

  public isVoiceCallManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.VOICE_CALL_MANAGE);
  }

  public isDismissSafetyEventsManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.DISMISS_SAFETY_EVENTS_MANAGE);
  }

  public isIdlingReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.IDLING_READ);
  }

  public isFuelInsightsAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.FUEL_INSIGHTS);
  }

  public isDriversReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.DRIVERS_READ);
  }

  public isDriversManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.DRIVERS_MANAGE);
  }

  public isVehiclesManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.VEHICLES_MANAGE);
  }

  public isFleetUsersManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.FLEET_USERS_MANAGE);
  }

  public isAssetsManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.ASSETS_MANAGE);
  }

  public isGroupsManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.GROUPS_MANAGE);
  }

  public isCoachDriverAssigned(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.COACH_DRIVER_ASSIGNED);
  }

  public isCoachSafetyEventsManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.COACH_SAFETY_EVENTS_MANAGE);
  }

  public isCoachLogsManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.COACH_LOGS_MANAGE);
  }

  public isAllowedToMarkEventsCoachable(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.MARK_EVENTS_COACHABLE_MANAGE);
  }

  public isAllowedToConductEventsCoaching(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CONDUCT_COACHING_EVENTS_MANAGE);
  }

  public isAllowedToMarkLogsCoachable(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.MARK_LOGS_COACHABLE_MANAGE);
  }

  public isAllowedToConductLogsCoaching(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CONDUCT_COACHING_LOGS_MANAGE);
  }

  public isCoachDriverPermitted(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.COACH_DRIVER_PERMITTED);
  }

  public isDevicesManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.ELD_DEVICES_MANAGE);
  }

  public isDeveloperAccessManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.DEVELOPER_ACCESS_MANAGE);
  }

  public isGeofenceManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.GEOFENCE_MANAGE);
  }

  public isAlertsManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.ALERTS_MANAGE);
  }

  public isCompanyManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.COMPANY_MANAGE);
  }

  public isVehicleGatewayAssignAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.VEHICLE_GATEWAY_ASSIGN);
  }

  public isUnsafeBehaviorDetectionSettingsReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.UNSAFE_BEHAVIOR_DETECTION_SETTINGS_READ);
  }

  public isVehiclesUnsafeBehaviorDetectionSettingManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.VEHICLES_UNSAFE_BEHAVIOR_DETECTION_SETTING_MANAGE);
  }

  public isAssetGatewayAssignAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.ASSET_GATEWAY_ASSIGN);
  }

  public isUserRolesManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.USER_ROLES_MANAGE);
  }

  public isDriverHubAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.DRIVER_HUB_MANAGE);
  }

  public isDriverWalkthroughAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.DRIVER_WALKTHROUGH_MANAGE);
  }

  public isThermokingControlManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.THERMOKING_CONTROL_MANAGE);
  }

  public isDispatchManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.DISPATCHES_MANAGE);
  }

  public isDispatchReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.DISPATCHES_READ);
  }

  public isSafetyVideoDownloadingAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.VIDEO_DOWNLOAD_READ) && this.session.isRemoteLoginVideoDownloadEnabled();
  }

  public isConfidentialVideoDownloadingAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CONFIDENTIAL_VIDEO_DOWNLOAD_READ);
  }

  public isDriverLicenseManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.DRIVER_LICENSE_MANAGE);
  }

  public isVirtualCardConfigurationManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.VIRTUAL_CARD_CONFIGURATION_MANAGE);
  }

  public isTimecardsReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.TIMECARDS_READ);
  }

  public isTimecardsManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.TIMECARDS_MANAGE);
  }

  public isWorkforceManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.WORKFORCE_MANAGE);
  }

  public isTimecardsSettingsManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.TIMECARDS_SETTINGS_MANAGE);
  }

  public isOemEntitiesReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.OEM_ENTITIES_READ);
  }

  public addFleetCardAdministrativePermissions(): void {
    ADMINISTRATIVE_PERMISSIONS.push(...FLEET_CARDS_ADMINISTRATIVE_PERMISSIONS);
    allPermissions.push(...FLEET_CARDS_ADMINISTRATIVE_PERMISSIONS);
  }

  public allowedFleetCardAdministrativePermissions(): string[] {
    return FLEET_CARDS_ADMINISTRATIVE_PERMISSIONS.filter((perm: PERMISSIONS): boolean => this.session.isFeatureAllowed(perm));
  }

  public hasFleetCardAdministrativePermission(permission?: PERMISSIONS): boolean {
    const checkSpecificPermission: boolean = !!permission;
    return checkSpecificPermission ?
      !!this.allowedFleetCardAdministrativePermissions().find((perm: PERMISSIONS): boolean => perm === permission) :
      !!this.allowedFleetCardAdministrativePermissions().length;
  }

  public allowedFleetCardDashboardPermissions(): string[] {
    return FLEET_CARDS_DASHBOARD_PERMISSIONS.filter((perm: PERMISSIONS): boolean => this.session.isFeatureAllowed(perm));
  }

  public hasFleetCardDashboardPermission(permission?: PERMISSIONS): boolean {
    const checkSpecificPermission: boolean = !!permission;
    return checkSpecificPermission ?
      !!this.allowedFleetCardDashboardPermissions().find((perm: PERMISSIONS): boolean => perm === permission) :
      !!this.allowedFleetCardDashboardPermissions().length;
  }

  public allowedDashboardPermissions(): string[] {
    return DASHBOARD_PERMISSIONS.filter((perm: PERMISSIONS): boolean => this.session.isFeatureAllowed(perm));
  }

  public hasDashboardPermission(permission?: PERMISSIONS): boolean {
    const checkSpecificPermission: boolean = !!permission;
    return checkSpecificPermission ?
      !!this.allowedDashboardPermissions().find((perm: PERMISSIONS): boolean => perm === permission) :
      !!this.allowedDashboardPermissions().length;
  }

  public allowedAdministrativePermissions(): string[] {
    return ADMINISTRATIVE_PERMISSIONS.filter((perm: PERMISSIONS) => this.session.isFeatureAllowed(perm));
  }

  public hasAdministrativePermission(permission?: PERMISSIONS): boolean {
    const checkSpecificPermission: boolean = !!permission;
    return checkSpecificPermission ?
      !!this.allowedAdministrativePermissions().find((perm: PERMISSIONS): boolean => perm === permission) :
      !!this.allowedAdministrativePermissions().length;
  }

  public hasLimitedGroupAccess(permission: PERMISSIONS): boolean {
    const companyConnection: IResponseCompanyConnection = this.session.getCompanyConnection();
    const restrictedGroups: number[] = companyConnection && companyConnection.permissions[permission];
    return restrictedGroups && restrictedGroups.length > 0;
  }

  public isManageMessagingTeamsAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.MESSAGING_TEAMS_MANAGE);
  }

  public isShopManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.SHOP_MANAGE);
  }

  public isBillingManagementManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.BILLING_MANAGEMENT_MANAGE)
    && (!this.session.isTrialCustomer() || this.session.getAccountStatus() === USER_ACCOUNT_TYPE.CUSTOMER);
  }

  public isAuditLogsManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.AUDIT_LOGS_READ);
  }

  public isFaceMatchManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.FACE_MATCH_MANAGE);
  }

  public isReportReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.REPORTS_READ);
  }

  public isDriverQualificationDocumentsManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.DRIVER_QUALIFICATION_DOCUMENTS_MANAGE);
  }

  public isDriverQualificationDocumentsReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.DRIVER_QUALIFICATION_DOCUMENTS_READ);
  }

  public isDriverQualificationDocumentsTemplateReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.DRIVER_QUALIFICATION_DOCUMENTS_TEMPLATE_READ);
  }

  public isDriverQualificationDocumentsTemplateManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.DRIVER_QUALIFICATION_DOCUMENTS_TEMPLATE_MANAGE);
  }

  public isMotiveAnalyticsReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.MOTIVE_ANALYTICS_READ);
  }

  public isMotiveAnalyticsManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.MOTIVE_ANALYTICS_MANAGE);
  }

  public isConfidentialReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CONFIDENTIAL_READ);
  }

  public isConfidentialAssignAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CONFIDENTIAL_ASSIGN);
  }

  public isConfidentialUnassignAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CONFIDENTIAL_UNASSIGN);
  }

  public isBehaviorTagsManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.BEHAVIOR_TAGS_MANAGE);
  }

  public isSeverityManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.SEVERITY_MANAGE);
  }

  public isTrainingReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.TRAINING_READ);
  }

  public isTrainingManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.TRAINING_MANAGE);
  }

  public isMVRManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.MVR_MANAGE);
  }

  public isCollisionReportManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.COLLISION_REPORT_MANAGE);
  }

  public isDriverPrivacyManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.DRIVER_PRIVACY_MANAGE);
  }

  // Fleet Cards

  public isBanksAndPaymentsManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.BANKS_AND_PAYMENTS_MANAGE);
  }

  public isPaymentsAndInvoicesReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.PAYMENTS_AND_INVOICES_READ);
  }

  public isCardTransactionReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CARD_TRANSACTION_READ);
  }

  public isCardMissedSavingsReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CARD_MISSED_SAVINGS_READ);
  }

  public isCardTransactionManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CARD_TRANSACTION_MANAGE);
  }

  public isCardHoldersReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CARD_HOLDERS_READ);
  }

  public isCardsAdminReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CARD_ADMIN_READ);
  }

  public isCardManagementReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CARD_MANAGEMENT_READ);
  }

  public isCardManagementManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CARD_MANAGEMENT_MANAGE);
  }

  public isCardConfigurationManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CARD_CONFIGURATION_MANAGE);
  }

  public isDriverCodesManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CARDS_CONFIGURATION_DRIVER_CODES_MANAGE);
  }

  // Fleet Cards - Granular permissions

  public isCardsPolicyManagementAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.POLICY_MANAGEMENT_MANAGE);
  }

  public isCardsOrderManagementReadAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CARD_ORDER_MANAGEMENT_READ);
  }

  public isCardsChangePoliciesAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CARD_MANAGEMENT_CHANGE_POLICIES);
  }

  public isCardsChangePoliciesTemporaryOverridesAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CARD_MANAGEMENT_CHANGE_POLICIES_TEMP_OVERRIDES);
  }

  public isCardsOrderManagementPhysicalCardsAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CARD_ORDER_MANAGEMENT_PHYSICAL_CARDS);
  }

  public isCardsLockUnlockAndFreezeAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CARD_MANAGEMENT_LOCK_UNLOCK_AND_FREEZE_CARDS);
  }

  public isCardsManageSecurityControlsAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CARD_MANAGEMENT_MANAGE_SECURITY_CONTROLS);
  }

  public isCardsManagementPhysicalCardsActivateDeactivateReassignAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CARD_MANAGEMENT_PHYSICAL_CARDS_ACTIVATE_DEACTIVATE_REASSIGN);
  }

  public isCardsManagementPhysicalAndVirtualCardsActivateAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CARD_MANAGEMENT_PHYSICAL_AND_VIRTUAL_CARDS_DEACTIVATE);
  }

  public isCardsManagementVirtualCardsActivateDeactivateAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.CARD_MANAGEMENT_VIRTUAL_CARDS_ACTIVATE_DEACTIVATE);
  }

  public isSafetyManageAllowed(): boolean {
    return this.session.isFeatureAllowed(PERMISSIONS.SAFETY_SETTINGS_MANAGE);
  }
}
